export default __webpack_public_path__ + "static/media/remove.360dbcc0.svg";